import React from "react";
import CurrencyFormat from '../components/Common/CurrencyFormat';
import { isNumber} from './chargeableItems';

// Create a string with the currency and the value to 2dp
const renderValueCurrencyString = (value, currencySymbol = "") => isNumber(value) 
  ? <CurrencyFormat value={value} currency={currencySymbol} displayType="text" /> 
  : "";

export default renderValueCurrencyString;